import { render, staticRenderFns } from "./HelpdeskArticle.vue?vue&type=template&id=536287e7&scoped=true"
import script from "./HelpdeskArticle.vue?vue&type=script&lang=ts"
export * from "./HelpdeskArticle.vue?vue&type=script&lang=ts"
import style0 from "./HelpdeskArticle.vue?vue&type=style&index=0&id=536287e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536287e7",
  null
  
)

export default component.exports